import { css } from "@emotion/react";

export const footer = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 1.5rem;
`;

export const privacyPolicy = css`
  text-align: center;

  padding: 1rem 0.5rem;
`;
